




































import { Component, Vue } from "vue-property-decorator";
import RenderEntry from "@/components/RenderEntry.vue";
import EntryEditor from "@/components/editor/editing/EntryEditor.vue";
import ItemInfoBar from "@/components/editor/base/ItemInfoBar.vue";
import WorkingOnIssuesList from "@/components/editor/base/WorkingOnIssuesList.vue";

@Component({
  components: {
    WorkingOnIssuesList,
    ItemInfoBar,
    EntryEditor,
    RenderEntry
  }
})
export default class EditEntry extends Vue {
  public updateRefs = 0;

  get label() {
    return this.$route.params.label;
  }
}
